
import { useState, useEffect } from 'react';

export type Role = 'OWNER' | 'FOREMAN' | 'ACCOUNTANT';

export const useRole = () => {
    const [role, setRole] = useState<Role>('OWNER');

    useEffect(() => {
        const savedRole = localStorage.getItem('lean_controls_role') as Role;
        if (savedRole) {
            setRole(savedRole);
        }
    }, []);

    const changeRole = (newRole: Role) => {
        localStorage.setItem('lean_controls_role', newRole);
        setRole(newRole);
        // Reload to apply UI gates cleanly
        window.location.reload();
    };

    return {
        role,
        changeRole,
        isOwner: role === 'OWNER',
        isForeman: role === 'FOREMAN',
        isAccountant: role === 'ACCOUNTANT',
    };
};
